import Service from "../../../Services/index";
const deposit = {
    namespaced: true,
    state: {
        deposit : [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        SET_DEPOSIT :(state, res) => {
            state.deposit = [];
            state.deposit = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.total
            }
        },
    },
    actions: {
        setDeposit({ commit },page) {
            return Service.Deposit.getDeposit(page)
                .then(data => {
                    commit("SET_DEPOSIT", data);
                });
        },
        showDepositTable({commit},data){
            return Service.Deposit.showDeposit(data.driver_id,data.page).then(res => {
                commit("SET_DEPOSIT", res);
            });
        },
        searchDetail({commit},data){
            return Service.Deposit.searchDetail(data).then(res => {
                commit("SET_DEPOSIT", res);
            });
        },
        save({commit},data){
            return Service.Deposit.createDeposit(data);
        },
        updateDeposit({commit},{id,data}){
            return Service.Deposit.updateDeposit(id,data);
        },
        searchDeposit({commit},{page,search}){
            return Service.Deposit.search(page,search)
                .then(data=>{
                    commit("SET_DEPOSIT",data)
                })
        },
    }
};
export default deposit;
